import { render, staticRenderFns } from "./abgeber.vue?vue&type=template&id=6f101c7a&"
import script from "./abgeber.vue?vue&type=script&lang=js&"
export * from "./abgeber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports